export default __webpack_public_path__ + "static/media/magicBox.1d73a744.png";